var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{staticClass:"bar-chart",staticStyle:{"max-width":"100%"},attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":_vm.chartId,"height":330}})}
var staticRenderFns = []

export { render, staticRenderFns }